import { Link } from 'react-router-dom';

import { RegistrationStatus } from '@sayyesschool/common/entities/registration';
import ActionButton from '@sayyesschool/frontend/components/action-button';
import ConfirmButton from '@sayyesschool/frontend/components/confirm-button';
import { MeetingRegistrationsStatusBar } from '@sayyesschool/frontend/features/registrations';
import {
    Chip,
    Flex,
    IconButton,
    Table,
    Text
} from '@sayyesschool/frontend/ui-components';

const columns = [
    { key: 'number', content: '№' },
    { key: 'title', content: 'Тема' },
    { key: 'date', content: 'Дата и время' },
    { key: 'host', content: 'Ведущий' },
    { key: 'level', content: 'Уровень' },
    { key: 'format', content: 'Формат' },
    { key: 'participants', content: 'Участники' },
    { key: 'actions' }
];

export default function MeetingsTable({
    meetings,
    onEdit,
    onPublish,
    onDelete
}) {
    return (
        <Table>
            <Table.Head>
                <Table.Row header>
                    {columns.map(column =>
                        <Table.Cell
                            key={column.key}
                            content={column.content}
                            header
                        />
                    )}
                </Table.Row>
            </Table.Head>

            <Table.Body>
                {meetings.map((meeting, index) =>
                    <Table.Row key={meeting.id}>
                        <Table.Cell>
                            {index + 1}
                        </Table.Cell>

                        <Table.Cell>
                            <Link to={`/meetings/${meeting.id}`}>
                                {meeting.title}
                            </Link>
                        </Table.Cell>

                        <Table.Cell>
                            <Flex column>
                                <Text as="span">{meeting.dateLabel}</Text>

                                <Text
                                    as="span"
                                    type="body-xs"
                                >{meeting.timeLabel}</Text>
                            </Flex>
                        </Table.Cell>

                        <Table.Cell>
                            {meeting.host ?
                                <Chip
                                    component={Link}
                                    to={`/users/${meeting.host.id}`}
                                    content={meeting.host.fullname}
                                />
                                :
                                '—'
                            }
                        </Table.Cell>

                        <Table.Cell>
                            {meeting.levelLabel || '—'}
                        </Table.Cell>

                        <Table.Cell>{meeting.online ? 'Онлайн' : 'Оффлайн'}</Table.Cell>

                        <Table.Cell>
                            {meeting.isEnded ?
                                <MeetingRegistrationsStatusBar
                                    registrations={meeting.registrations}
                                    statuses={[
                                        RegistrationStatus.Attended,
                                        RegistrationStatus.Missed,
                                        RegistrationStatus.Canceled
                                    ]}
                                />
                                :
                                <MeetingRegistrationsStatusBar
                                    registrations={meeting.registrations}
                                    statuses={[
                                        RegistrationStatus.Pending,
                                        RegistrationStatus.Approved,
                                        RegistrationStatus.Canceled
                                    ]}
                                />
                            }
                        </Table.Cell>

                        <Table.Cell align="end">
                            <IconButton.Group size="sm">
                                <ActionButton
                                    title={meeting.published ? 'Опубликована' : 'Не опубликована'}
                                    icon={meeting.published ? 'public' : 'public_off'}
                                    color={meeting.published ? 'primary' : 'neutral'}
                                    onAction={() => onPublish(meeting)}
                                />

                                <IconButton
                                    title="Изменить"
                                    icon="edit"
                                    onClick={() => onEdit(meeting)}
                                />

                                <ConfirmButton
                                    title="Удалить"
                                    message="Удалить встречу?"
                                    icon="delete"
                                    color="danger"
                                    onConfirm={() => onDelete(meeting)}
                                />
                            </IconButton.Group>
                        </Table.Cell>
                    </Table.Row>
                )}
            </Table.Body>
        </Table>
    );
}